import React, {useEffect, useState, Fragment} from 'react';
import DialogoPantallaCompleta from 'components/Dialogo/DialogoPantallaCompleta';
import { Card, CardContent } from '@mui/material';
import IndicadorDeCarga from 'components/IndicadorDeCarga';
import AlertaDeRespuesta from 'components/AlertaDeRespuesta';
import { Cancel, DeleteOutlined, Save } from '@mui/icons-material';
import Modal from 'components/Modales/ModalDeConfirmacion';
import Formulario from 'components/formulario';
import { TablaPersonalizada } from 'components';
import { functions } from 'constantes/functions';
import TooltipPersonalizado from 'components/tooltip/TooltipPersonalizado';
import { useDispatch, useSelector } from 'react-redux';
import { nuevoOActualizarRegistroPersonalizado, obtenerDepartamentosPersonalizado, obtenerMunicipiosPersonalizado, obtenerRegistrosPersonalizado } from 'store/actions/customAction';
import { nombreDeAcciones } from 'constantes';
import ServiciosDelAPI from 'servicios/ServiciosDelAPI';
import { mesesDelAnio } from 'constantes/globalsStates';
import ModalDeConfirmacion from 'components/Modales/ModalDeConfirmacion';
let datosDeDisponibilidad = [];

const NuevaPantallDigital= ({title, openFullScreenDialog, handleClose, datosDeEmpresa, idTipoDeMedio}) => {
  const dispatch = useDispatch();
  const {datosGenerales} = useSelector((state) => state);
  const { tarifarioYDisponibilidad} = useSelector( ({nuevoTarifario}) => nuevoTarifario);

  const [datosDeRespuesta, setDatosDeRespuesta] = useState({ tipoDeAlerta: 'error', mensajeDeAlerta: '', mostrarRespuesta: false, });
  const[cargandoSolicitud, setcargandoSolicitud] = useState(false),
  [mostrarEliminarElemento, setMostrarEliminarElemento] = useState(false),
  [datosDelElemento, setDatosDelElemento] = useState({});
  const[listadoDeDisponibilidades, setListadoDeDisponibilidades] = useState([]);
  const [mostrarAlertaDeErrorOExito, setMostrarAlertaDeErrorOExito] = useState(false);
  const [tarifarioDePantallasDigitales] = useState('tarifarioDePantallasDigitales');
  const [catalogoSentidoVisualizacion] = useState('catalogoSentidoVisualizacion');
  const [catalogoDepartamentos] = useState('catalogoDepartamentos');
  const [catalogoMunicipios] = useState('catalogoMunicipios');
  datosDeDisponibilidad = listadoDeDisponibilidades;
  const [departamentoYMunicipio, setDepartamentoYMunicipio] = useState({departamento: {}, municipio: {}})

  const [encabezadoDeTabla] = useState([
    { title: 'Fecha desde', field: 'fechaDesde', render: (rowData) => functions.FormatearFecha(rowData.fechaDesde || "")},
    { title: 'Fecha hasta', field: 'fechaHasta', render: (rowData) => functions.FormatearFecha(rowData.fechaHasta || "")},
    { title: 'Cantidad disponible', field: 'cantidadDisponible.name', cellStyle:{ maxWidth: '80px'}},
    { title: 'Acción', field: 'accion',
    render: rowData=><div style={{minWidth: '100px'}}>
        {
            (<div>
                <TooltipPersonalizado title="Eliminar disponibilidad del listado" handleFunction={()=> removerElemento(rowData)} icon={<DeleteOutlined />} color="red" marginTop={0} fontSize={30} />
            </div>)
        }
        </div>
    },
  ]);

  const removerElemento = (rowItem) => {
    setDatosDelElemento(rowItem)
    setMostrarEliminarElemento(true);
  }

  useEffect(() => {
    obtenerSentidoDeVisualizacion();
    obtenerDepartamentos();
  },[])

  const obtenerSentidoDeVisualizacion = async () => {
    const copiaDeCampos = Object.assign({}, camposDelFormulario);

    if(datosGenerales.tipoSentidoDeVisualizacion.length > 0) {
        copiaDeCampos.sentidoDeVisualizacion.list = datosGenerales.tipoSentidoDeVisualizacion?.map( ({id, descripcion}) => ({id , name: descripcion}) );
        return setCamposDelFormulario(copiaDeCampos);
    }

    setcargandoSolicitud(true);
    let respuesta = await dispatch(obtenerRegistrosPersonalizado({
        controller: catalogoSentidoVisualizacion,
        validateIfDataExists: true,
        stateInStore: datosGenerales.tipoSentidoDeVisualizacion,
        dispatchAction: nombreDeAcciones.SETEAR_TIPO_DE_VISUALIZACION,
    }));

    setcargandoSolicitud(false);

    if(respuesta?.error || respuesta?.data?.length === 0) return setDatosDeRespuesta({ tipoDeAlerta: 'error', mensajeDeAlerta: respuesta?.error?.message || "", mostrarRespuesta: true, });

    copiaDeCampos.sentidoDeVisualizacion.list = respuesta?.data?.map( ({id, descripcion}) => ({id , name: descripcion}) )
    setCamposDelFormulario(copiaDeCampos);
  }

  const obtenerDepartamentos =async ()=> { 
    setcargandoSolicitud(true);
    const copiaDeCampos = Object.assign({}, camposDelFormulario);

    if(datosGenerales.departamentos.length > 0) {
        if(datosGenerales.departamentos.length > 22 ) datosGenerales.departamentos.shift()
      copiaDeCampos.departamento.list = datosGenerales.departamentos?.map( ({id, nombre}) => ({id, name: nombre}) );
      setcargandoSolicitud(false);
      return setCamposDelFormulario(copiaDeCampos);
    }

    const dataCustomFetch = {
        controller: catalogoDepartamentos,
        validateIfDataExists: true,
        stateInStore : datosGenerales?.departamentos,
        dispatchAction:  nombreDeAcciones.OBTENER_DEPARTAMENTOS,
    }

    const respuesta = await dispatch(obtenerDepartamentosPersonalizado(dataCustomFetch));
    setcargandoSolicitud(false);

    if(respuesta?.error) setDatosDeRespuesta({ tipoDeAlerta: 'error', mensajeDeAlerta: respuesta?.error?.message || "", mostrarRespuesta: true, });

    let datos = respuesta?.data?.map( ({id, nombre}) => ({id , name: nombre}) )
    copiaDeCampos.departamento.list = datos;
    setCamposDelFormulario(copiaDeCampos);
  };

  const obtenerMunicipios =async ({target}) => {
      const newState = Object.assign({}, camposDelFormulario);

      if(!target.value) {
          newState.municipio.list = [];
          newState.municipio.value = null;
          return;
      };

      setcargandoSolicitud(true);
      const dataCustomFetch = {
          controller: catalogoMunicipios,
          stateInStore : datosGenerales?.catalogos?.municipios,
          dispatchAction: nombreDeAcciones.OBTENER_MUNICIPIOS,
          departamentoID: target?.value
      }
      ServiciosDelAPI[catalogoMunicipios].metodoDeBusqueda.clear();
      ServiciosDelAPI[catalogoMunicipios].metodoDeBusqueda.setOperator("and");
      ServiciosDelAPI[catalogoMunicipios].metodoDeBusqueda.addEquals("departamento.id", target?.value);
      const respuesta = await dispatch(obtenerMunicipiosPersonalizado(dataCustomFetch));

      setcargandoSolicitud(false);
      if(respuesta?.error) {
          newState.municipio.list = [];
          newState.municipio.value = null;
          setDatosDeRespuesta({ errorType: 'error', messageType: respuesta.error?.message || "No se pudieron obtener los municipios", openResponse: true, });
      }

      let datos = respuesta?.data?.map( ({id, nombre}) => ({id , name: nombre}) )
      newState.municipio.list = datos;
      newState.municipio.value = null;
      setCamposDelFormulario(newState);
  };

  const cerrarModalEliminarElemento = () => setMostrarEliminarElemento(false);

  const accionEliminarElemento = async () => {
    const listadoConElementoELliminado = listadoDeDisponibilidades.filter((item) => item.id !== datosDelElemento.id)
    const listadoMayoresAlElemento = listadoConElementoELliminado.filter( ({posicion}) => posicion > datosDelElemento.posicion);

    if(listadoMayoresAlElemento.length > 0 ) {
        setMostrarEliminarElemento(false);
        return setDatosDeRespuesta({ tipoDeAlerta: 'warning', mensajeDeAlerta: `NO PUEDE ELIMINAR LA DISPONIBILIDAD PORQUE TIENE RANGOS DE FECHA MAYORES AL QUE ESTA ELIMINADO!.`, mostrarRespuesta: true, });
    }

    const newData = listadoConElementoELliminado
    setListadoDeDisponibilidades(newData);
    setMostrarEliminarElemento(false);
    setearFechaMinima(datosDelElemento.fechaDesde, "")
  }

  const calcularPromedio = () => {
    const newElements = Object.assign({}, camposDelFormulario)
    const {julio, agosto, septiembre, octubre, noviembre, diciembre} = camposDelFormulario;
    const promedio = Number(julio?.value) + Number(agosto?.value) + Number(septiembre?.value) + Number(octubre?.value) + Number(noviembre?.value) + Number(diciembre.value)
    newElements.promedio.value = (promedio / 6).toFixed(3);
    setCamposDelFormulario(newElements)
  }

  const agregarDisponibilidadAlListado = () => {

    const newElements = Object.assign({}, camposDelFormulario)
    const patterns = {
        cantidad: '^[1-9][0-9]*$',
        fecha: '^[0-9]{1,2}[/][0-9]{1,2}[/][0-9]{4}$'
    }
    const {fechaDesde, fechaHasta, cantidadDisponible} = newElements;

    if(fechaDesde?.value > fechaHasta?.value) return setDatosDeRespuesta({ tipoDeAlerta: 'warning', mensajeDeAlerta: `LA FECHA DESDE ES MAYOR A LA FECHA HASTA!.`, mostrarRespuesta: true, });

    if(!cantidadDisponible.value || !cantidadDisponible.value.id.toString().match(patterns.cantidad)) newElements.cantidadDisponible.isError = true;
    else newElements.cantidadDisponible.isError = false;

    if(!fechaDesde.value || JSON.stringify(fechaDesde.value) === 'null' || !fechaDesde.value.toLocaleDateString('es-ES').match(patterns.fechaDesde)) newElements.fechaDesde.isError = true;
    else newElements.fechaDesde.isError = false;

    if(!fechaHasta.value || JSON.stringify(fechaHasta.value) === 'null' || !fechaHasta.value.toLocaleDateString('es-ES').match(patterns.fechaHasta)) newElements.fechaHasta.isError = true;
    else newElements.fechaHasta.isError = false;

    if(fechaDesde.isError || fechaHasta.isError || cantidadDisponible.isError) return setCamposDelFormulario(newElements);

    let elementoActual = "";
    if(datosDeDisponibilidad.length > 0 ) {
        const existElement = datosDeDisponibilidad.some((item) => {
            elementoActual = item.fechaHasta;
            return fechaDesde.value <=  item.fechaHasta
        })
        if(existElement) return setDatosDeRespuesta({ tipoDeAlerta: 'warning', mensajeDeAlerta: `NO PUEDE INGRESAR UNA FECHA MENOR O IGUAL A ${functions.formatearFechaDD_MM_YYYY(elementoActual)}.`, mostrarRespuesta: true, });
    }

    setListadoDeDisponibilidades( prevState => [{ id: new Date().getTime(), fechaDesde: fechaDesde.value, fechaHasta: fechaHasta.value, cantidadDisponible: cantidadDisponible.value, posicion: prevState.length + 1}, ...prevState])
    setearFechaMinima(fechaHasta.value, "")
  }

  const setearFechaMinima = (fecha, operacion) => {
    const newElements = Object.assign({}, camposDelFormulario)
    const nuevaFecha = new Date(fecha.getFullYear(), fecha.getMonth(), operacion === 'suma' ? fecha.getDate() + 1 : fecha.getDate());
    newElements.fechaDesde.minDate = nuevaFecha;
    newElements.fechaHasta.minDate = nuevaFecha;
    newElements.fechaDesde.value = nuevaFecha;
    newElements.fechaHasta.value = nuevaFecha;
    setCamposDelFormulario(newElements);
  }

  const [camposDelFormulario, setCamposDelFormulario] = useState({
    tituloCobertura:{
      idelement: "tituloCobertura", title:'Departamento y Municipio', position:"center", elementType:'titulo', showTitleForm: true,  name: "tituloCobertura", value: "", isError:false,
    },
    departamento: {
        idelement: "departamento", value: null , label: "Seleccione el departamento *", pattern:"^[0-9]{1,}$", validators: ['required'],
        errorMessages:['Seleccione una opción'], isError:false, showSelectAutoComplete: true, elementType:'autoCompletar', list: [], handler: obtenerMunicipios, width: '40%', marginTop: '10px'
    },
    municipio: {
        idelement: "municipio", value: null , label: "Seleccione el municipio *", pattern:"^[0-9]{1,}$", validators: ['required'],
        errorMessages:['Seleccione una opción'], isError:false, showSelectAutoComplete: true, elementType:'autoCompletar', list: [], handler: undefined, width: '40%', marginTop: '10px'
    },
    tituloPantallaDigital:{
        idelement: "tituloPantallaDigital", title:'Datos de la pantalla digital', position:"center", elementType:'titulo', showTitleForm: true, name: "tituloPantallaDigital", value: "", isError:false,
    },
    anchoPantalla: {
        idelement: "anchoPantalla", value: "", label: `Ancho (cm) *`, pattern:"^\\d+(.\\d+)?$", validators: ['required'], errorMessages:['El campo es requerido y solo números'], isError:false, elementType:'texto', name:"anchoPantalla", 'disabled': false, width: '33%',
    },
    altoPantalla: {
        idelement: "altoPantalla", value: "", label: `Alto (cm) *`, pattern:"^\\d+(.\\d+)?$", validators: ['required'], errorMessages:['El campo es requerido y solo números'], isError:false, elementType:'texto', name:"altoPantalla", 'disabled': false, width: '33%',
    },
    coordenadasDeUbicacion: {
        idelement: "coordenadasDeUbicacion", value: "", label: `Coordenadas de ubicación *`,
        pattern:"^([-+]?\\d{1,2}[.]\\d+),\\s*([-+]?\\d{1,3}[.]\\d+)?$", validators: ['required'], errorMessages:['El campo es requerido y solo números'], isError:false, elementType:'texto', name:"coordenadasDeUbicacion", 'disabled': false, width: '33%',
    },
    sentidoDeVisualizacion: {
      idelement: "sentidoDeVisualizacion", value: null , label: "Sentido de visualización *", pattern:"^[1-9][0-9]*$", validators: ['required'],
      errorMessages:['Seleccione una opción'], isError:false, showSelectAutoComplete: true, elementType:'autoCompletar', list: [], handler: undefined, width: '50%', marginTop: '0'
      },
      imagenDeLaPantalla:{
        idelement: "imagenDeLaPantalla", value: "", label: "Imagen de la pantalla", validators: {required: true,  size: "8 MB",}, errorMessages: 'Por favor debe adjuntar lo solicitado', isError:false, elementType:'archivo','disabled':false, name:"imagenDeLaPantalla", fileWidth: true, src: '', multiple: false, accept:".png, .jpg", showInMovil: true, width: '49%', type: "file"
      },
      ubicacionDePantalla:{
        idelement: "ubicacionDePantalla", value: "", label: `Ubicación de la pantalla digital`, pattern:"^[\\w\\s\\á-úÁ-Ú\\-\\,.#_“”()-*_/@]{4,2000}$", validators: ['required'],
        errorMessages:['El campo es requerido'], isError:false, elementType:'areaTexto','disabled':false, fullWidth: true, name: "ubicacionDePantalla", width: '100%'
      },
      tarifario:{
          idelement: "tarifario", title:'Tarifario', position:"center", elementType:'titulo', showTitleForm: true, name: "tarifario", value: "", isError:false,
      },
      alertaSpots:{
          idelement: "alertaSpots", mensaje:'TARIFA COMERCIAL POR SPOT DE 10 SEGUNDOS DE LOS ÚLTIMOS SEIS MESES', elementType:'alerta', showAlertForm: true, name: "alertaSpots", value: "", isError:false, severity: 'error'
      },
      alertaTarifa:{
          idelement: "alertaTarifa", mensaje:'LA TARIFA COMERCIAL NO DEBE SUPERAR EL PROMEDIO DE LA TARIFA COMERCIAL DEBE SER INGRESADA EN QUETZALES (Q) DEBE INCLUIR IVA Y TIMBRE DE PRENSA', elementType:'alerta', showAlertForm: true, name: "alertaTarifa", value: "", isError:false, severity: 'error'
      },
      tarifaComercial:{
          idelement: "tarifaComercial", title:'Tarifa', position:"center", elementType:'titulo', showTitleForm: true, name: "tarifaComercial", value: "", isError:false,
      },
      julio: {
          idelement: "julio",  value: "", label: "JUL *", pattern:"^\\d+(.\\d+)?$", validators: ['required'], errorMessages:['El campo es requerido  y solo números'], isError:false, elementType:'texto', name:"julio", 'disabled': false, width: '14%', manejadorDeCambio: calcularPromedio
      },
      agosto: {
          idelement: "agosto",  value: "", label: "AGO *", pattern:"^\\d+(.\\d+)?$", validators: ['required'], errorMessages:['El campo es requerido  y solo números'], isError:false, elementType:'texto', name:"agosto", 'disabled': false, width: '14%',  manejadorDeCambio: calcularPromedio
      },
      septiembre: {
          idelement: "septiembre",  value: "", label: "SEP *", pattern:"^\\d+(.\\d+)?$", validators: ['required'], errorMessages:['El campo es requerido  y solo números'], isError:false, elementType:'texto', name:"septiembre", 'disabled': false, width: '14%',  manejadorDeCambio: calcularPromedio
      },
      octubre: {
          idelement: "octubre",  value: "", label: "OCT *", pattern:"^\\d+(.\\d+)?$", validators: ['required'], errorMessages:['El campo es requerido  y solo números'], isError:false, elementType:'texto', name:"octubre", 'disabled': false, width: '14%',  manejadorDeCambio: calcularPromedio
      },
      noviembre: {
          idelement: "noviembre",  value: "", label: "NOV *", pattern:"^\\d+(.\\d+)?$", validators: ['required'], errorMessages:['El campo es requerido  y solo números'], isError:false, elementType:'texto', name:"noviembre", 'disabled': false, width: '14%',  manejadorDeCambio: calcularPromedio
      },
      diciembre: {
          idelement: "diciembre",  value: "", label: "DIC *", pattern:"^\\d+(.\\d+)?$", validators: ['required'], errorMessages:['El campo es requerido  y solo números'], isError:false, elementType:'texto', name:"diciembre", 'disabled': false, width: '14%',  manejadorDeCambio: calcularPromedio
      },
      promedio: {
          idelement: "promedio",  value: "", label: "PROMEDIO *", pattern:"^\\d+(.\\d+)?$", validators: ['required'], errorMessages:['El campo es requerido  y solo números'], isError:false, elementType:'texto', name:"promedio", 'disabled': true, width: '14%'
      },
      tituloDisponibilidad:{
          idelement: "tituloDisponibilidad", title:'Disponibilidad', position:"center", elementType:'titulo', showTitleForm: true,  name: "tituloDisponibilidad", value: "", isError:false,
      },
      alertaDisponibilidad:{
          idelement: "alertaDisponibilidad", mensaje:'LA DISPONIBILIDAD MINIMA SOLICITADA ES DE 160 SPOTS DE 10 SEGUNDOS POR CADA DÍA DISPONIBLE.', elementType:'alerta', showAlertForm: true, name: "alertaDisponibilidad", value: "", isError:false, severity: 'error'
      },
      fechaDesde: {
          idelement: "fechaDesde", value: null, label: "DESDE: *", pattern:"",
          validators: ['required'], errorMessages:['fecha dd/MM/yyyy'], isError:false, elementType:'fecha' , disabled: false, width: '30%', minDate: new Date()
      },
      fechaHasta: {
          idelement: "fechaHasta", value: null, label: "HASTA *", pattern:"",
          validators: ['required'], errorMessages:['fecha dd/MM/yyyy'], isError:false, elementType:'fecha' , disabled: false, width: '30%', minDate: new Date()
      },
      cantidadDisponible: {
          idelement: "cantidadDisponible", value: null , label: "Cantidad por día disponible *", pattern:"", validators: ['required'],
          errorMessages:['Seleccione una opción'], isError:false, showSelectAutoComplete: true, elementType:'autoCompletar', list: [{id: 1, name: "80"}, {id: 2, name: "160"}, {id: 3, name: "320"}, {id: 4, name: "640"},], handler: undefined, width: '30%', marginTop: '0'
      },
      boton:{
          idelement: "boton", elementType:'boton', name: "boton", value: "", isError:false, icon: "add_circle", handleFunction: agregarDisponibilidadAlListado, title: "Agregar disponibilidad al listado", color: "#53C22B", marginTop: "5px"
      },
      acciones: {
          idelement: "acciones", title:'Acciones', position:"center", elementType:'titulo', showTitleForm: true, name: "acciones", value: "", isError:false,
      },
  });

    const guardarDatos = async (dataForm) => {

        if(datosDeDisponibilidad.length === 0) {
            return setDatosDeRespuesta({ tipoDeAlerta: 'warning', mensajeDeAlerta: `DEBE DE INGRESAR AL MENOS UNA DISPONIBILIDAD!.`, mostrarRespuesta: true, });
        }

        setcargandoSolicitud(true);
        const { departamento, municipio, anchoPantalla, altoPantalla, coordenadasDeUbicacion, sentidoDeVisualizacion, imagenDeLaPantalla, ubicacionDePantalla, julio, agosto, septiembre, octubre, noviembre, diciembre } = dataForm;

        const fechasDeDisponibilidad = datosDeDisponibilidad.map(({fechaDesde, fechaHasta, cantidadDisponible}) =>
        ({
            "cantidadDisponible": Number(cantidadDisponible.name),
            "fechaFinal": functions.formatearFechaDD_MM_YYYY(fechaHasta),
            "fechaInicial": functions.formatearFechaDD_MM_YYYY(fechaDesde)
        }))

        const datosAGuardar = {
            disponibilidad: {
                fechasDeDisponibilidad
            },
            tarifarioPorMes: [
              {
                  "numeroDeMes": mesesDelAnio["julio"],
                  "tarifaDeMes": Number(julio)
              },
              {
                  "numeroDeMes": mesesDelAnio["agosto"],
                  "tarifaDeMes": Number(agosto)
              },
              {
                  "numeroDeMes": mesesDelAnio["septiembre"],
                  "tarifaDeMes": Number(septiembre)
              },
              {
                  "numeroDeMes": mesesDelAnio["octubre"],
                  "tarifaDeMes": Number(octubre)
              },
              {
                  "numeroDeMes": mesesDelAnio["noviembre"],
                  "tarifaDeMes": Number(noviembre)
              },
              {
                  "numeroDeMes": mesesDelAnio["diciembre"],
                  "tarifaDeMes": Number(diciembre)
              },
            ],
            alto: altoPantalla,
            ancho: anchoPantalla,
            coordenadas: coordenadasDeUbicacion,
            sentidoVisualizacion: sentidoDeVisualizacion.id,
            departamento: departamento.id,
            municipio: municipio.id,
            descripcionUbicacion: ubicacionDePantalla,
            nitEmpresa: datosDeEmpresa.nit,
            logo: imagenDeLaPantalla
        }

        let datosAEnviar = {};
        let response = {};

        if(idTipoDeMedio) {
            datosAGuardar.idInforme = idTipoDeMedio
            datosAEnviar = { controller: tarifarioDePantallasDigitales, action: 'editar', data: datosAGuardar };
            response = await dispatch(nuevoOActualizarRegistroPersonalizado(datosAEnviar));
        } else {
            datosAEnviar = { controller: tarifarioDePantallasDigitales, action: 'crear', data: datosAGuardar };
            response = await dispatch(nuevoOActualizarRegistroPersonalizado(datosAEnviar));
        }
        setcargandoSolicitud(false);

        if(response?.error) return setDatosDeRespuesta({ tipoDeAlerta: 'warning', mensajeDeAlerta: response.error?.message || "REGISTRO NO INGRESADO. INTENTE NUEVAMENTE", mostrarRespuesta: true, });
        setDepartamentoYMunicipio({departamento, municipio})
        setMostrarAlertaDeErrorOExito(true);

    }

    const [listadoDeBotones]= useState({
        "guardarDatos":{"label":"Guardar Datos", "icon": <Save />, "callback":guardarDatos,"loading":false,"size":"medium",
                "background":"linear-gradient(45deg, #205690 30%, #3890EE 90%)", "border":"0px", "borderRadius":"3",
                "boxShadow":"0 3px 5px 2px rgba(33, 203, 243, .3)", "color":"white", "height":37, padding:"0 30px", disabled: false,
                isCancel: false,
        },
        "cancelar":{"label":"Cancelar", "icon": <Cancel />,"callback":handleClose,"loading":false,"size":"medium",
                "background":"linear-gradient(45deg, #B90000 30%, #E07777 90%)", "border":"0px", "borderRadius":"3",
                "boxShadow":"0 3px 5px 2px rgba(33, 203, 243, .3)", "color":"white", "height":37, padding:"0 30px",  disabled: false,
                isCancel: true,
        },
    });

    const handClose = (_, reason) => {
        if (reason === 'clickaway') {return}
        changeDataResponse('error', '', false)
    };

    const changeDataResponse = (tipoDeAlerta, mensajeDeAlerta, mostrarRespuesta = false) => {
        setDatosDeRespuesta({tipoDeAlerta,mensajeDeAlerta,mostrarRespuesta,})
    };

    const cerrarAlertaDeConfirmacion = () => {
        handleClose(true)
        setMostrarAlertaDeErrorOExito(false);
    }

    const manejadorAccionDelModal = async () => {

        functions.reiniciarEstadoDelFormulario(camposDelFormulario)
        const copiaElementos = Object.assign({}, camposDelFormulario);

        const {departamento, municipio} = departamentoYMunicipio;

        copiaElementos.departamento.value = {id: departamento?.id, name: departamento?.name}
        copiaElementos.municipio.value = {id: municipio?.id, name: municipio?.name}
        copiaElementos.ubicacionDePantalla.value = "";
        copiaElementos.fechaDesde.value = null;
        copiaElementos.fechaHasta.value = null;

        setCamposDelFormulario(copiaElementos);
        setListadoDeDisponibilidades([])
        setMostrarAlertaDeErrorOExito(false);
    }

    const { tipoDeAlerta, mensajeDeAlerta, mostrarRespuesta} = datosDeRespuesta;

    return (
        <DialogoPantallaCompleta
            openFullScreenDialog={openFullScreenDialog}
            handleClose={handleClose}
            title={title}
            fullscreen={true}
        >
        <Fragment>
            {cargandoSolicitud ? <IndicadorDeCarga open={cargandoSolicitud} /> : '' }
            <AlertaDeRespuesta type={tipoDeAlerta} content={mensajeDeAlerta} open={mostrarRespuesta} handClose={handClose}/>

            <Card>
                <CardContent>
                    <Formulario
                        elements={camposDelFormulario}
                        buttonList={listadoDeBotones}
                    />
                    <TablaPersonalizada
                        pageSize={10}
                        data={listadoDeDisponibilidades}
                        title={"Listado de disponibilidades"}
                        header={encabezadoDeTabla}
                    />
                </CardContent>
            </Card>
            {mostrarEliminarElemento && (
                <Modal
                    title={`¿Está seguro de eliminar la disponibilidad?`} message={"No podrá revertir esta acción"}
                    open={mostrarEliminarElemento} closeModal={cerrarModalEliminarElemento} titleButton={"Sí, estoy seguro"}
                    actionAdd={accionEliminarElemento}
                />
            )}
            {mostrarAlertaDeErrorOExito && (
                <ModalDeConfirmacion
                    title={`¿Desea agregar otra pantalla en este municipio?`} message={"¡REGISTRADO CORRECTAMENTE!"}
                    open={mostrarAlertaDeErrorOExito} closeModal={cerrarAlertaDeConfirmacion} titleButton={"Sí, agregar"}
                    actionAdd={manejadorAccionDelModal}
                />
            )}
        </Fragment>
        </DialogoPantallaCompleta>
    );
}

export default NuevaPantallDigital;